import { SBIcon } from '@supplement-bacon/react-toolkit/components'
import { tuttiFruttiPalette } from '@utils/colors'
import { Permission } from '@utils/permissions'
import { HELP_CENTER_ARTICLES_URL } from '@utils/urls'
import { Avatar, Flex, Typography } from 'antd'
import { Link } from 'react-router-dom'
import { useHasAccess } from './HasAccess'

const { Title } = Typography

interface QuickAction {
  key: string
  title: string
  hasAccess: boolean
  icon: string
  link: string
  color: string
}

const QuickActions = () => {
  const { hasAccess } = useHasAccess()

  const quickActionsList: QuickAction[] = [
    {
      key: 'manageVenue',
      title: 'Create venue',
      hasAccess: hasAccess(Permission.listVenue),
      icon: 'HomeOutlined',
      link: '/venues/list?action=create&entity=venue',
      color: tuttiFruttiPalette[14],
    },
    {
      key: 'createCampaign',
      title: 'Send push',
      hasAccess: hasAccess(Permission.listPush),
      icon: 'NotificationOutlined',
      link: '/marketing/campaigns',
      color: tuttiFruttiPalette[18],
    },
    {
      key: 'createFeaturedVenue',
      title: 'Promote venue',
      hasAccess: hasAccess(Permission.listFeaturedVenue),
      icon: 'HomeOutlined',
      link: '/marketing/featured-venue?action=create&entity=featuredVenue',
      color: tuttiFruttiPalette[12],
    },
    {
      key: 'reviewRequests',
      title: 'Review requests',
      hasAccess: hasAccess(Permission.manageMembersMembership),
      icon: 'FormOutlined',
      link: '/membership/requests',
      color: tuttiFruttiPalette[30],
    },
    {
      key: 'createEvent',
      title: 'Create event',
      hasAccess: hasAccess(Permission.manageEventsMembership),
      icon: 'CalendarOutlined',
      link: '/membership/events/list?action=create&entity=event',
      color: tuttiFruttiPalette[27],
    },
    {
      key: 'inviteAdmin',
      title: 'Invite admin',
      hasAccess: hasAccess(Permission.createAdmin),
      icon: 'UserAddOutlined',
      link: '/settings/admins?action=create&entity=admin',
      color: tuttiFruttiPalette[6],
    },
    {
      key: 'createCompany',
      title: 'Create company',
      hasAccess: hasAccess(Permission.manageBusiness),
      icon: 'CreditCardOutlined',
      link: '/business/companies/list?action=create&entity=company',
      color: tuttiFruttiPalette[9],
    },
    {
      key: 'createPolicy',
      title: 'Create policy',
      hasAccess: hasAccess(Permission.manageBusiness),
      icon: 'CreditCardOutlined',
      link: '/business/policies?action=create&entity=policy',
      color: tuttiFruttiPalette[9],
    },
    {
      key: 'readDocs',
      title: 'Read docs',
      hasAccess: true,
      icon: 'BookOutlined',
      link: HELP_CENTER_ARTICLES_URL,
      color: tuttiFruttiPalette[19],
    },
  ]
  const renderCell = (quickAction: QuickAction) => {
    return (
      <Link key={quickAction.key} to={quickAction.link}>
        <Flex vertical align="center" justify="center" gap={5}>
          <Avatar
            size={50}
            icon={<SBIcon name={quickAction.icon} />}
            shape="square"
            style={{ backgroundColor: quickAction.color }}
          />
          <Title level={5} className="m-0">
            {quickAction.title}
          </Title>
        </Flex>
      </Link>
    )
  }
  return (
    <Flex
      gap={30}
      wrap
      align="center"
      justify="center"
      style={{ maxWidth: 700 }}
    >
      {quickActionsList
        .filter((action) => action.hasAccess)
        .map((action) => renderCell(action))}
    </Flex>
  )
}

export default QuickActions
